module.exports = __webpack_public_path__ + "static/media/c7bannerModulF_small.2be10b5b.jpg";